import ComentarioComp from './ComentarioComp'
export default ComentarioComp



// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/Comentarios/index.js